<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import ProductPricePage from '~/components/market/ProductPricePage.vue'

import type { TSeoByPages } from '~/src/types/seo'
import {
  LITHIUM,
  SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM,
} from '~/constants/services/constants'
import lithiumData from '~/constants/price-assessments/unauthorized/lithium'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({
  layout: 'services',
  name: 'lithium-prices-nested',
})

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_LITHIUM
const data = {
  product: LITHIUM,
  productData: lithiumData,
  subscription,
}

/*-------------------------------------
  SEO
-------------------------------------*/
const seoByPages = {
  table: {
    title: 'Lithium Prices, Data & Market Analysis',
    description:
      'Benchmark lithium prices are assessed to the highest IOSCO standard to support supply contract settlement, indexation and price risk management.',
  },
  chart: {
    title: 'Lithium Price Charts & Data Visualisation',
    description:
      'Lithium price charts and analysis are available on hand from Benchmark Mineral Intelligence, providing transparency into price movements and market dynamics.',
  },
  index: {
    title: 'Lithium Price Index',
    description:
      "Benchmark's team of expert analysts collect market data to mineral-specific, IOSCO-compliant methodologies in order to assess prices for lithium.",
  },
  'price-customisation-tool': {
    title: 'Lithium Price Customisation Tool',
    description:
      "With Benchmark's lithium price customisation tool, you can create your own custom pricing charts using Benchmark's world-leading, IOSCO-assured prices and data.",
  },
}

const { params } = useRoute()
const { getSeoInfo } = useSeo()
const seo = getSeoInfo(
  seoByPages[(params.slug as keyof TSeoByPages) || 'table'],
)
useHead(seo)
</script>
